import api from "../services/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

export const syncWebPushSubscription = async () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
  if (!window.isSecureContext) return;
  if (Notification.permission !== "granted") return;

  const { data } = await api.get("/web-push/public-key");
  const publicKey = data?.publicKey;

  if (!publicKey) return;

  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const swUrl = `${publicUrl}/service-worker.js`;
  let registration = await navigator.serviceWorker.getRegistration();

  if (!registration) {
    registration = await navigator.serviceWorker.register(swUrl);
  }

  await navigator.serviceWorker.ready;
  const applicationServerKey = urlBase64ToUint8Array(publicKey);
  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey
    });
  }

  await api.post("/web-push/subscribe", {
    subscription: subscription.toJSON()
  });
};
